// Terminal-style line with optional prompt prefix.
// <TerminalLine>$ hello world</TerminalLine>
// <TerminalLine prompt="shukan">init</TerminalLine>

interface Props {
  children: React.ReactNode;
  prompt?: boolean | string;
  accent?: boolean;
  danger?: boolean;
  dim?: boolean;
  as?: "div" | "p" | "li" | "h1" | "h2" | "h3" | "span";
  style?: React.CSSProperties;
}

export function TerminalLine({
  children,
  prompt = false,
  accent = false,
  danger = false,
  dim = false,
  as: As = "div",
  style,
}: Props) {
  const customStyle = {
    ...style,
    ...(accent ? { color: "var(--accent)" } : {}),
    ...(danger ? { color: "var(--danger)" } : {}),
  };

  return (
    <As
      className={["shukan-line", prompt ? "shukan-prompt" : "", dim ? "opacity-60" : ""].join(" ").trim()}
      style={Object.keys(customStyle).length > 0 ? customStyle : undefined}
    >
      {children}
    </As>
  );
}
